<template>
  <div >
    <h2 style="color: #dd6161">软件说明</h2>


    <p style="font-weight: bold;color: #3a8ee6">1、软件使用中遇到问题，请点右上角【联系客服】。</p>
    <p style="font-weight: bold;color: #3a8ee6">2、新版同步订单和显示数据不在同一页显示，同步订单后，请点【显示数据】。</p>
    <p style="font-weight: bold;color: #3a8ee6">3、在【同步订单】页面点【从服务器下载】，下载显示顺序，可显示之前保存的显示列。</p>
    <p style="font-weight: bold;color: #3a8ee6">4、要调整显示列的显示顺序，在【同步订单】页面点【调整顺序】。</p>
    <p style="font-weight: bold;color: #3a8ee6">5、对软件有其他功能需求，请联系客服进行 【定制功能】。</p>
    <p><el-button v-show="false" type="primary" @click="login">模拟登录</el-button></p>
    <p>
      <el-image :src="connect" style=""></el-image>
    </p>

    <div align="center" style="margin-top: 300px; ">
      <span style="font-size: 12px">Copyright ©2020 ZDINFO.TOP 版权所有
        <el-link href="http://www.beian.miit.gov.cn"  type="primary" style="margin-left: 10px;font-size: 12px">豫ICP备17046731号</el-link></span>
    </div>
  </div>
</template>

<script>
    import $api from "../api/axios";
    import storage from "../api/storage";

    export default {
        name: "Index",
        data(){
          return {
            connect:'./static/image/connect.png',
          }
        },
      methods:{
          login:function () {
            let param = {
              nick:"l*****u",
              venderId:"10383272",
              sessionkey:"6407b54aa5ed419d857dc6b1fe6ef3e2wn2i"
            }
            $api.post("/login", param, response => {
              let dataResult = response.data;
              if(dataResult.state == 1){
                storage.set("nick", dataResult.data.nick);
                storage.set("venderId", dataResult.data.venderId);
                storage.set("days", 98);
                storage.set("token", dataResult.data.token);

              }
            })
          }
      },
      mounted(){
          //this.$message.warning("软件试运行期间，使用中遇到问题，请点右上角QQ【联系客服】");
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/Index.vue